import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/hand-spock': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M21.1 381.8c-27-25.4-28.2-67.7-2.9-94.7 24.2-25.7 64.3-28.2 91.5-5.7l-31-136.5c-9.4-41.3 21.4-81 64.1-81.8 1.7-28.9 22.3-54.5 51.9-61.3 36-8.3 72 14.2 80.3 50.3l21.7 132 16.9-105.3c9-36.1 45.4-57.7 81.3-48.8 27.3 6.8 45.7 29.1 49.8 54 43.2-0.2 75.6 40.1 65.5 82.5l-31.7 133.4c-0.9 3.9-1.4 8-1.4 12v36.8 0c0 9.3-2.1 24.1-4.8 33l-31.8 107.3c-4 13.6-16.5 22.9-30.7 22.9h-237.6c-7 0-16.8-3.9-21.9-8.7zM53.2 320c-7.2 7.6-6.8 19.7 0.8 26.9l124.5 117.2h219.3l28.4-95.9c1.9-6.3 2.8-12.8 2.8-19.3v-36.8c0-6.5 1.2-16.9 2.7-23.2l31.8-133.4c5.8-24.5-31.1-33.3-37-8.8l-26.9 113.1c-1.6 6.8-8.6 12.3-15.6 12.3h-9.7c-10.4 0-18-9.8-15.5-19.9l38.1-152.5c6.1-24.4-30.8-33.6-36.9-9.2l-42.4 169.5c-1.7 6.7-8.6 12.1-15.5 12.1h-13.2v0c-7 0-14-5.6-15.6-12.4l-45.2-196.8c-5.6-24.6-42.7-16-37 8.5l41.6 181.2c2.3 10-5.3 19.6-15.6 19.6h-8.6 0c-7 0-14-5.6-15.6-12.5l-30.4-133.8c-5.6-24.4-42.7-16.2-37.1 8.4l34.1 150.2c0.3 1.2 0.4 2.4 0.4 3.5v69.5c0 14-16.8 21.2-27 11.7l-53-49.9c-7.6-7.2-19.6-6.9-26.9 0.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/hand-spock.js
// module id = 1773
// module chunks = 0